import { render, staticRenderFns } from "./ServiceEntry.vue?vue&type=template&id=89de41a4&"
import script from "./ServiceEntry.vue?vue&type=script&lang=js&"
export * from "./ServiceEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports